module.exports = __webpack_public_path__ + "static/n95-mask-china-quality-5adf00bb38f29d826f3e866355683675.png";